<section class="py-lg-4 mb-xl-10">
  <!-- <p class="fs-1 fs-md-2 fw-bold mb-0">
      {{ "COURSES.RECOMMEND_COURSE" | translate }} :
      {{ category.name }}
    </p> -->
  <div class="row">
    <div class="col-12 col-lg-3 mb-6 mb-lg-0">
      <div class="card">
        <div class="card-body" [formGroup]="form">
          <!--begin::Member-->
          @if (isLoading()) {
          <ng-container *ngTemplateOutlet="skeletonLeftSide"></ng-container>
          } @else {
          <div class="d-flex flex-column">
            <h4 class="text-gray-900 mb-7">
              {{ "APP.SEARCH_BLOG" | translate }}
            </h4>

            <div class="position-relative">
              <i class="ki-duotone ki-magnifier fs-3 text-gray-500 position-absolute top-50 translate-middle ms-6"><span
                  class="path1"></span><span class="path2"></span></i>
              <input type="text" class="form-control form-control-solid ps-10" name="search" value=""
                [placeholder]="'APP.SEARCH' | translate" formControlName="keywords" />
            </div>
            <div class="separator mt-6 mb-3"></div>
            <div class="">
              <app-radio name="blog_category" label="APP.CATEGORIES" [labelMode]="LabelMode.DEFAULT"
                labelStyle="fw-semibold fs-4 text-gray-900" formControlName="blog_category_id"
                [options]="blogCategories"></app-radio>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-9">
      <div class="card card-flush h-xl-100 min-h-350px">
        <!--begin::Header-->
        <div class="card-header pt-7">
          <!--begin::Title-->
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bold text-gray-900">{{
              "APP.TOTAL_BLOG" | translate
              }}</span>
            <span class="text-gray-500 mt-1 fw-semibold fs-6">
              {{ blogs.length }} {{ "APP.ITEMS" | translate }}</span>
          </h3>
        </div>

        <div class="card-body">
          <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 g-6">
            @if (tableLoading()) {
            <ng-container *ngTemplateOutlet="skeletonGroup"></ng-container>
            } @else {
            @if (blogs.length) {
            @for (blog of blogs; track blog; let j = $index) {
            <app-blog-item class="hover-elevate-up" data-testid="blog-row" [data]="blog"
              [routerLink]="`/blogs/${blog.id}`"></app-blog-item>
            }
            } @else {
            <!-- "ไม่มีรายการ" alone in a white card says nothing about what
                     to do next. The manual's search gets this right; this is
                     the same shape. -->
            <div class="col-12 w-100">
              <div class="empty-state" data-testid="blog-empty">
                <span class="empty-state__mark">
                  <app-keenicon name="notepad" class="fs-2tx"></app-keenicon>
                </span>
                <p class="empty-state__title">{{ "APP.BLOG_EMPTY" | translate }}</p>
                <p class="empty-state__body">{{ "APP.BLOG_EMPTY_HINT" | translate }}</p>
              </div>
            </div>
            }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #skeletonLeftSide>
  <div class="d-flex flex-column">
    <div class="skeleton h-20px w-75 mb-4"></div>
    <div class="skeleton h-40px w-100 mt-4 mb-4"></div>
    <div class="separator mt-2 mb-6"></div>

    <div class="skeleton h-20px w-50 mb-4"></div>
    <div class="d-flex flex-row align-items-center gap-2 mb-4">
      <div class="skeleton h-20px w-20px rounded-circle"></div>
      <div class="skeleton h-15px w-50"></div>
    </div>
    <div class="d-flex flex-row align-items-center gap-2 mb-4">
      <div class="skeleton h-20px w-20px rounded-circle"></div>
      <div class="skeleton h-15px w-50"></div>
    </div>
    <div class="d-flex flex-row align-items-center gap-2 mb-4">
      <div class="skeleton h-20px w-20px rounded-circle"></div>
      <div class="skeleton h-15px w-50"></div>
    </div>
  </div>
</ng-template>

<ng-template #skeletonGroup>
  <ng-container *ngTemplateOutlet="skeleton"></ng-container>
  <ng-container *ngTemplateOutlet="skeleton"></ng-container>
  <ng-container *ngTemplateOutlet="skeleton"></ng-container>
  <ng-container *ngTemplateOutlet="skeleton"></ng-container>
</ng-template>

<ng-template #skeleton>
  <div>
    <div class="card px-0">
      <div class="card-body d-flex flex-column justify-content-between p-2">
        <div class="d-flex flex-column">
          <div class="skeleton h-200px w-100"></div>
          <div class="px-2">
            <div class="skeleton h-15px w-100 mt-5 mb-2"></div>
            <div class="skeleton h-10px w-100 mb-4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
